// 埋点文档 https://doc.baijia.com/sheets/RTdhVyhHD8vXpkG3/LFaSA

const TEN_YEARS_EVENT_ID_MAP = {
    十周年报告页面曝光: 13084133014595584,
    十周年报告页面停留时长: 13084137877104640,
    十周年报告查看报告: 13084142696818688,
    十周年报告音乐播放态切换: 13084145882523648,
    十周年报告翻页: 13084149792598016,
    十周年报告去拍照: 13084152854767616,
    十周年报告拍照弹窗点击: 13084162805884928,
    十周年报告尾页btn点击: 13084170014844928,
    十周年报告分享弹窗曝光: 13084173365372928,
    十周年报告分享: 13084175961057280,
    十周年聚合页页面曝光: 13096016281757696,
    十周年各板块曝光: 13118127494817792,
    十周年奖池点击: 13096029656213504,
    十周年蛋糕按钮点击: 13096036193822720,
    十周年子活动板块点击: 13096039472654336,
    十周年签到: 13096042729531392,
    十周年做任务: 13096049496451072,
    十周年领取奖励: 13096052861396992,
    十周年奖励弹窗曝光: 13096058456205312,
    十周年公益页曝光: 13096063314126848,
    十周年公益参与点击: 13096068546521088,
}

const EVENT_ID_MAP = {
    高途APP_H5下载页面曝光: 10826297269839872,
    下载高途APP的入口点击: 10826298570663936,
    视频列表页曝光: 10826299620157440,
    视频播放按钮点击: 10826300597823488,
    全屏_退出全屏按钮点击: 10826301615138816,
    视频列表页点击单个视频: 10826302586316800,
    目录按钮点击: 10826303506966528,
    横屏播放时切换视频点击: 10826304498198528,
    倍速按钮点击: 10826305722476544,
    添加图书_添加图书页面浏览: 10989382510274560,
    添加图书_添加图书按钮点击: 10989383899244544,
    添加图书_去学习按钮点击: 10989384790337536,
    添加图书_添加失败确认按钮点击: 10989385944754176,
    添加图书_切换账号按钮点击: 10989388262172672,
    游戏化目录_浏览事件: 10989430984960000,
    游戏化目录_章节点击事件: 11027890650376192,
    游戏化目录_徽章点击事件: 10989432959625216, // 停用
    游戏化目录_无视频弹窗浏览事件: 10989435338450944,
    游戏化目录_无视频弹窗立即批改按钮点击事件: 10989436616337408,
    游戏化目录_错题本入口点击: 11362826757236736,
    视频列表_浏览事件: 10989457394198528,
    视频列表_视频点击事件: 10989470758758400,
    视频列表_立即批改按钮点击事件: 10989472920463360,
    视频列表_答题卡按钮点击事件: 11249651125217280,
    视频列表_视频列表拍照批改按钮点击事件: 11249655241598976, // 停用
    图书列表_浏览事件: 11027670088443904,
    图书列表_图书点击事件: 11027675874551808,
    图书列表_扫码看视频点击事件: 11027677556271104,
    图书列表_拍照批改点击事件: 11027678928988160,
    高中图书目录_浏览事件: 11027869980846080,
    高中图书目录_章节点击事件: 11027878498625536,
    高中图书目录_无视频弹窗浏览事件: 11027886589044736,
    高中图书目录_无视频弹窗立即批改按钮点击事件: 11250171227564032, // 停用
    高中图书目录_错题本入口点击: 11362831233607680,
    批改详情页_视频解析点击事件: 11051567759255552,
    权益冻结弹窗曝光事件: 11492233209866240,
    权益冻结弹窗_确定按钮点击事件: 11492240271042560,
    权益冻结弹窗_联系客服按钮点击事件: 11492242085144576, // 停用
    徽章曝光事件: 11492287948154880,
    徽章点击事件: 11492420652918784,
    节页面_卡片曝光事件: 11652129293166592,
    节页面_语音测评点击事件: 11652132251330560,
    节页面_语音测评展开收起点击事件: 11652133629093888,
    节页面_读音播放事件: 11658045956843520,
    下载引导页_下载_打开APP按钮曝光: 11698065829488640,
    绑定引导页浏览事件: 11730129467107328,
    绑定点击事件: 11730130832615424,
    跳过点击事件: 11730132063971328,
    升级app页面曝光: 11787755275249664,
    节任务页面_音频点击事件: 11726364947474432,
    音频播放页面_浏览事件: 11730183454681088,
    音频播放页面_音频原文切换tab点击事件: 11730186964199424,
    音频播放页面_前进后退15s点击事件: 11730191066556416,
    音频播放页面_自动连播点击事件: 11730199152257024,
    音频播放页面_上一首下一首点击事件: 11730204856379392,
    音频播放页面_播放列表曝光事件: 11730228792158208,
    音频播放页面_播放列表点击事件: 11730232776353792,
    音频播放页面_播放按钮点击事件: 11730234929276928,
    // 使用统一的页面浏览事件 ID
    PDF列表页曝光: 13644449351493632,
    PDF预览页面_浏览事件: 10434379647117312,
    PDF列表页单个文件点击: 13644445632063488,
    节任务页_听力题模块曝光: 11883891482912768, // 停用
    节任务页_听力题模块点击: 11883893535827968,
    节任务页_听力题模块展开点击: 11883894811092992,
    是否继续弹窗曝光: 11883897241036800,
    是否继续弹窗_从头开始点击: 11883898442246144,
    是否继续弹窗_继续听写点击: 11883899457136640,
    题目预览页_浏览: 11883905632659456,
    题目预览页_开始听写点击: 11883907019466752,
    听写页_浏览: 11883908773472256,
    听写页_播放按钮点击: 11883911506323456,
    听写页_上一题点击: 11883919515150336,
    听写页_下一题点击: 11883920459393024,
    听写页_读词次数点击: 11883922221197312,
    听写页_读词间隔点击: 11883923284781056,
    听写页_查看本题答案: 11883933277054976,
    听写页_题目列表点击: 11883937071654912,
    听写结果页_浏览: 11883939035572224,
    听写结果页_原文重听点击: 11883940245366784,
    听写结果页_再听一遍点击: 11883941087504384,
    站外引导下载弹窗_曝光: 11650621172443136,
    节任务页_听学读背模块曝光: 12086622538328064, // 停用
    节任务页_听学读背模块点击: 12086628599228416,
    听学读背列表页浏览: 12086632598890496,
    听学读背模块曝光: 12086684897077248,
    听学读背模块点击: 12086653946456064,
    读课文主页曝光: 12086690057447424,
    录音按钮点击: 12086701048424448,
    设置字号按钮点击: 12086720128182272,
    // 提交按钮点击: 12086723255625728,
    读课文报告页浏览: 12086725087029248,
    再读一次点击: 12086725925234688,
    开始背诵点击事件: 12086728909875200,
    背课文主页曝光: 12086735211358208, // 停用
    提示按钮点击: 12086736948258816,
    背课文报告页浏览: 12086738014791680, // 停用
    站外打开APP引导条曝光: 12086741390157824, // 停用
    站外打开APP引导条点击: 12086746809919488, // 停用
    未登录状态登录条曝光: 12086748465883136,
    未登录状态登录条点击: 12086751544764416,
    作文批改模块曝光事件: 12120908425422848, // 停用
    作文批改模块点击事件: 12120921245181952, // 停用
    作文题目页面浏览: 12120950870992896,
    拍照上传按钮点击: 12120963150735360,
    查看记录按钮点击: 12120965349992448,
    批改结果页面曝光: 12120972497938432,
    反馈按钮点击: 12120989596346368,
    批改结果_报错页面浏览: 12121063576922112,
    错题本入口曝光: 12290503529228288,
    登录页面曝光: 12579620058523648,
    登录成功事件: 12579623046440960,
    批改结果模块点击: 12568275474016256,
    批改结果模块曝光: 12568277813913600,
    有无帮助模块曝光: 12568815533516800,
    有帮助点击: 12568827213146112,
    无帮助点击: 12568828377262080,
    明细说明按钮点击: 12839894930450432,
    立即购买按钮点击: 12931974997764096,
    次数购买弹层浏览: 12931971975768064,
    次数购买提示弹窗浏览: 13043726838818816,
    去购买按钮点击: 13043728555796480,
    高途私域运营位曝光: 13555486086293504,
    高途私域运营位点击: 13555492288751616,
    高途私域运营位关闭: 13555494142699520,
    视频end运营位曝光: 13729077080975360,
    视频end运营位关闭: 13729081181104128,
    ...TEN_YEARS_EVENT_ID_MAP,
} as const

export type IEventName = keyof typeof EVENT_ID_MAP;

export const EVENT_ID_CHECK_MAP: {
  [P in IEventName]?: string[];
} = {
    高途APP_H5下载页面曝光: ['grade'],
    下载高途APP的入口点击: ['grade'],
    视频列表页曝光: ['grade'],
    视频播放按钮点击: ['grade'],
    全屏_退出全屏按钮点击: ['grade'],
    添加图书_添加图书页面浏览: ['grade'],
    添加图书_添加图书按钮点击: ['grade'],
    添加图书_去学习按钮点击: ['grade'],
    添加图书_添加失败确认按钮点击: ['grade'],
    添加图书_切换账号按钮点击: ['grade'],
    游戏化目录_浏览事件: ['grade'],
    游戏化目录_章节点击事件: ['grade'],
    游戏化目录_无视频弹窗浏览事件: ['grade'],
    游戏化目录_无视频弹窗立即批改按钮点击事件: ['grade'],
    游戏化目录_错题本入口点击: ['grade'],
    视频列表_浏览事件: ['grade'],
    视频列表_立即批改按钮点击事件: ['grade'],
    视频列表_答题卡按钮点击事件: ['grade'],
    图书列表_浏览事件: ['grade'],
    图书列表_图书点击事件: ['grade'],
    高中图书目录_错题本入口点击: ['grade'],
    权益冻结弹窗曝光事件: ['grade'],
    权益冻结弹窗_确定按钮点击事件: ['grade'],
    徽章曝光事件: ['grade'],
    徽章点击事件: ['grade'],
    节页面_卡片曝光事件: ['grade'],
    节页面_语音测评点击事件: ['grade'],
    节页面_读音播放事件: ['grade'],
    下载引导页_下载_打开APP按钮曝光: ['grade'],
    节任务页面_音频点击事件: ['grade'],
    音频播放页面_浏览事件: ['grade'],
    音频播放页面_音频原文切换tab点击事件: ['grade'],
    音频播放页面_自动连播点击事件: ['grade'],
    音频播放页面_播放列表点击事件: ['grade'],
    PDF预览页面_浏览事件: ['grade'],
    节任务页_听力题模块点击: ['grade'],
    节任务页_听力题模块展开点击: ['grade'],
    题目预览页_浏览: ['grade'],
    节任务页_听学读背模块点击: ['grade'],
    听学读背列表页浏览: ['grade'],
    未登录状态登录条曝光: ['grade'],
    未登录状态登录条点击: ['grade'],
    作文题目页面浏览: ['grade'],
    拍照上传按钮点击: ['grade'],
    查看记录按钮点击: ['grade'],
    批改结果页面曝光: ['grade'],
    错题本入口曝光: ['grade'],
}

/**
 * @description: 根据名称获取eventId
 * @param eventName: 埋点名称
 * @return eventId
 */
export const getEventId = (eventName: IEventName) => EVENT_ID_MAP[eventName]
